import React from "react";
import { MdFolderOpen, MdBusinessCenter, MdAccessTime } from "react-icons/md";
import image1 from "../../../../assets/img/auth/background-data-value.png";
import Card from "../../../../components/card";

const Project = ({ projectDetail }) => {
  return (
    <Card extra={"w-full p-4 h-full"}>
      {/* Header */}
      <div className="mb-5 flex items-center gap-3">
        <span className="dv-aura flex h-11 w-11 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow">
          <MdFolderOpen className="h-6 w-6" aria-hidden="true" />
        </span>
        <div>
          <h4 className="text-lg font-bold text-navy-700 dark:text-white">
            Meus projetos
          </h4>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            Acompanhe os projetos em que você está alocado e as horas apontadas
          </p>
        </div>
      </div>

      {projectDetail.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-12 text-center dark:border-white/10 dark:bg-navy-900/40">
          <MdFolderOpen
            className="h-10 w-10 text-gray-400"
            aria-hidden="true"
          />
          <p className="mt-3 text-sm font-semibold text-navy-700 dark:text-white">
            Nenhum projeto encontrado
          </p>
          <p className="mt-1 text-sm text-gray-700 dark:text-gray-300">
            Você ainda não possui horas apontadas neste período.
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {projectDetail.map((row: any, index: any) => (
            <div
              key={index}
              className="flex w-full items-center gap-4 rounded-2xl border border-gray-100 bg-white p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-dv-md dark:border-white/10 dark:!bg-navy-900"
            >
              <img
                className="h-[72px] w-[72px] shrink-0 rounded-xl object-cover"
                src={image1}
                alt=""
                aria-hidden="true"
              />
              <div className="min-w-0 flex-1">
                <p
                  className="flex items-center gap-1.5 truncate text-base font-bold text-navy-700 dark:text-white"
                  title={row.NmCorporate}
                >
                  <MdBusinessCenter
                    className="h-4 w-4 shrink-0 text-gray-400"
                    aria-hidden="true"
                  />
                  {row.NmCorporate}
                </p>
                <p
                  className="mt-1 truncate text-sm font-medium text-gray-700 dark:text-gray-300"
                  title={row.NmProject}
                >
                  {row.NmProject}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-dv-blue-500/10 px-2.5 py-1 text-[11px] font-semibold tabular-nums text-dv-blue-600 dark:bg-dv-blue-500/20 dark:text-dv-cyan-300">
                  <MdAccessTime className="h-3.5 w-3.5" aria-hidden="true" />
                  {row.TotalHour} h apontadas
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default Project;
